const Loader = function () {
    const loadImages = (items, key, cb) => {
        let images = []

        if (key) {
            images = items.map(item => item[key])
        } else {
            images = items
        }

        if (images.length === 0) {
            return cb()
        }

        let i = 0

        images.forEach(src => {
            const img = new Image()

            const load = function () {
                i++

                if (i === images.length) {
                    cb()
                }
            }

            img.onload = load
            img.onerror = load

            img.src = src
        })
    }

    return {
        loadImages
    }
}

export default Loader



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.factory.js